module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEgAAABIBAMAAACnw650AAAAFVBMVEUAAABIQ1dJSVtFQFRFQVRFQFREQFT5vi7tAAAABnRSTlMANRzpprZhxD65AAAAdUlEQVRIx2MYBSQAFbM0rCDZCaGGCaYGU5UCXBFLGk7gAFfEjFuRAVwRG25FCciKghBshIQqmiIFbIqY0BQh2MgSo4pGFdFQEZROhCgSS0sYVURFRYMlgkcVDUlFhKsNwhUQ4aqMcKVIQvVKuKImXOWPAuIBAHSyDHqZPaEEAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/base/hotel_wardrobe.png
// module id = W5Wq
// module chunks = 0